export default __webpack_public_path__ + "static/media/fromTheFrugalToTheOrnateBanner.2f06d4e6.png";